import { LicenseProductIdEnum } from '@nirvana/shared/license-helper';

export enum LicenseChangeMessageType {
  Edr = 0,
  Companion = 1,
  IntegrityMonitor = 2,
  NadAndEraAddon = 3,
  WebAccessAndDeviceControlAddon = 4,
}

export enum RefreshTooltipCase {
  RecentlyUsed = 0,
  NoTooltip = 1,
}
export const dependentLicenses = [
  LicenseProductIdEnum.ProductIdXdrProductivitySensors,
  LicenseProductIdEnum.ProductIdXdrNetworkSensors,
  LicenseProductIdEnum.ProductIdXdrCloudSensors,
  LicenseProductIdEnum.ProductIdXdrIdentitySensors,
  LicenseProductIdEnum.ProductIdRemoteAccess,
  LicenseProductIdEnum.ProductIdXdrSensitiveDataSensors,
];

export enum LicensingTabEvents {
  LicenseOptionsChange = 'companyLicenseOptionsChange',
  LicensingTabRefresh = 'companyLicensingTabRefresh',
  LicensingGridProductBuyClick = 'companyLicensingGridProductBuyClick'
}
